import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit, HostListener } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { interval, Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { FOOTER_TEXT_KEY, environment } from '@environments/environment';
import { version } from '@environments/version';
import { getProductName } from '@pipes/getProductName.pipe';
type footerInformationType = {
  key: string;
  text: string;
  route?: string;
  link?: string;
  isShow: boolean;
  order: number;
  projectControl: string[];
  target: string;
}[];
@Component({
  selector: 'footer-component',
  templateUrl: '../sharedTemplates/footer.component.html',
})
export class FooterComponent implements OnInit, AfterViewInit {
  private translator = new TranslatePipe(this._LocalizationService);
  public footerInformationData: footerInformationType = [];
  public footerCompanyData: footerInformationType = [];

  private footerInformation: footerInformationType = [
    {
      key: 'footer_help_center',
      text: this.translator.transform('footer_help_center'),
      link: 'https://help.wettarena.de',
      isShow: true,
      order: 1,
      projectControl: ['wettarena'],
      target: '_blank',
    },
    {
      key: 'footer_help_center',
      text: this.translator.transform('footer_help_center'),
      link: 'https://help-center.bet3000.de/hc/de',
      isShow: true,
      order: 1,
      projectControl: ['b3000'],
      target: '_blank',
    },
    {
      key: 'Addiction_prevention',
      text: this.translator.transform('Addiction_prevention'),
      route: `/article/${this.translator.transform('route_article_footer_1')}`,
      isShow: true,
      order: 2,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'footer_payment_options',
      text: this.translator.transform('footer_payment_options'),
      route: `/article/${this.translator.transform('route_article_footer_2')}`,
      isShow: true,
      order: 3,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'responsible_gaming',
      text: this.translator.transform('responsible_gaming'),
      route: `/article/${this.translator.transform('route_article_footer_3')}`,
      isShow: true,
      order: 4,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'footer_privacy_cookies',
      text: this.translator.transform('footer_privacy_cookies'),
      route: `/article/${this.translator.transform('route_article_footer_4')}`,
      isShow: true,
      order: 5,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'terms_and_conditions',
      text: this.translator.transform('terms_and_conditions'),
      route: `/article/${this.translator.transform('route_article_footer_5')}`,
      isShow: true,
      order: 6,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'lugas_faq',
      text: this.translator.transform('lugas_faq'),
      route: `/article/${this.translator.transform('route_article_footer_9')}`,
      isShow: true,
      order: 7,
      projectControl: [],
      target: '_self',
    },
  ];
  private footerCompany: footerInformationType = [
    {
      key: 'footer_imprint',
      text: this.translator.transform('footer_imprint'),
      route: `/article/${this.translator.transform('route_article_footer_8')}`,
      isShow: true,
      order: 1,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'route_article_footer_7',
      text: this.translator.transform('AboutUs'),
      route: `/article/${this.translator.transform('route_article_footer_7')}`,
      isShow: true,
      order: 2,
      projectControl: [],
      target: '_self',
    },
    {
      key: 'franchise',
      text: this.translator.transform('franchise'),
      link: 'https://wettarena-shop.com/',
      isShow: true,
      order: 3,
      projectControl: ['wettarena'],
      target: '_blank',
    },
  ];
  footerText: { [key: string]: string } = FOOTER_TEXT_KEY;
  isOpenLangMenu = false;
  langDatas;
  langDatasArry = [];
  selectedLang = '';
  //bet300
  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  VERSION_TEXT = version;
  //bet3000

  depositList = [];

  leagueData = [
    {
      ExtensionData: {},
      CategoryId: 106,
      IsoName: 'de',
      TournamentId: 3793,
      TournamentName: 'Champions League',
      TournamentSportEventCount: 10,
      TournamentText: this.translator.transform('tournament_champions_league', null),
    },
    {
      ExtensionData: {},
      CategoryId: 13,
      IsoName: 'de',
      TournamentId: 16,
      TournamentName: 'Bundesliga',
      TournamentSportEventCount: 18,
      TournamentText: this.translator.transform('tournament_bundesliga_1', null),
    },
    {
      ExtensionData: {},
      CategoryId: 13,
      IsoName: 'de',
      TournamentId: 80,
      TournamentName: '2nd Bundesliga',
      TournamentSportEventCount: 9,
      TournamentText: this.translator.transform('tournament_bundesliga_2', null),
    },
    {
      ExtensionData: {},
      CategoryId: 1,
      IsoName: 'gb',
      TournamentId: 107,
      TournamentName: 'Premier League',
      TournamentSportEventCount: 13,
      TournamentText: this.translator.transform('tournament_premier_league', null),
    },
    {
      ExtensionData: {},
      CategoryId: 15,
      IsoName: 'gb',
      TournamentId: 28935,
      TournamentName: 'LaLiga',
      TournamentSportEventCount: 10,
      TournamentText: this.translator.transform('tournament_primera_division', null),
    },
    {
      ExtensionData: {},
      CategoryId: 16,
      IsoName: 'tr',
      TournamentId: 133,
      TournamentName: 'Super Lig',
      TournamentSportEventCount: 17,
      TournamentText: this.translator.transform('tournament_superliga', null),
    },
    {
      ExtensionData: {},
      CategoryId: 14,
      IsoName: 'it',
      TournamentId: 236,
      TournamentName: 'Serie A',
      TournamentSportEventCount: 19,
      TournamentText: this.translator.transform('tournament_serie_a', null),
    },
  ];

  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;

  defaultImg = 'angular/dist/assets/images/default.jpg';
  lazyHansaImg = 'angular/dist/assets/images/hansa.png';
  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;
  @HostListener('touchend', ['$event'])
  @HostListener('touchstart', ['$event'])
  onExit() {
    this.state.next('cancel');
  }
  @HostListener('touchstart', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) return '';

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24') return '';

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            const translator = new TranslatePipe(this._LocalizationService);
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = translator.transform(result.message, null);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                  this.signOut();
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }
  constructor(
    private _router: Router,
    public _LocalizationService: LocalizationService,
    private _ApiService: ApiService,
    public _UserHelper: UserHelper,
    public _UiHelper: UiHelper,
    private _DataHelper: DataHelper
  ) {
    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
  }

  ngOnInit() {
    this.getDeposit();
    this.footerInformationRebuild('information', this.footerInformation);
    this.footerInformationRebuild('company', this.footerCompany);
  }

  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }
  refreshAPP() {
    window.location.href = '/home';
  }
  // ScrollToTop(){

  footerInformationRebuild(select: string, informationData: footerInformationType): void {
    const getProductControl = new getProductName();
    const showInformationData = informationData.filter(i => i.isShow);
    if (showInformationData.length > 0) {
      const projectControlData = showInformationData.filter(i => i.projectControl.length === 0 || i.projectControl.includes(getProductControl.transform(i.projectControl)));
      if (projectControlData.length > 0) {
        if (select === 'information') {
          this.footerInformationData = projectControlData.sort((a, b) => a.order - b.order);
        } else if (select === 'company') {
          this.footerCompanyData = projectControlData.sort((a, b) => a.order - b.order);
        }
      }
    }
  }

  ngAfterViewInit() {
    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }

  getDeposit() {
    this._ApiService
      .getAllDepositControl()
      .then(result => {
        this.depositList = result;
      })
      .catch(err => console.log('footer', err));
  }

  showDetail(e, DepositTypeId = 0) {
    if (!this._UserHelper.isSignedIn) {
      this._router.navigate(['/register']);
      window.scroll(0, 0);
      return;
    }

    if (e == 'depositcreditcard') {
      this._router.navigate(['/depositcreditcard']);
    } else if (e == 'coinbase') {
      this._router.navigate(['/depositcoin']);
    } else if (e == 'paydox') {
      this._router.navigate(['/depositpaydox']);
    } else if (e == 'paydox2') {
      this._router.navigate(['/depositpaydox2']);
    } else if (e == 'irgate') {
      this._router.navigate(['/depositirgate']);
    } else if (e == 'apcopay') {
      this._router.navigate(['/depositapco/0']);
    } else if (e == 'uberweisen') {
      this._router.navigate(['/depositou', 0, DepositTypeId]);
    } else if (e == 'sofort') {
      this._router.navigate(['/depositsofort', 0, DepositTypeId]);
    } else if (e == 'apcocashtocode') {
      this._router.navigate(['/depositcashtocode/3', DepositTypeId]);
    } else if (e == 'apcoecow') {
      this._router.navigate(['/depositapco/2', DepositTypeId]);
    } else if (e == 'apcomuch') {
      this._router.navigate(['/depositapco/1', DepositTypeId]);
    } else if (e == 'apcoicardvisa') {
      this._router.navigate(['/depositapco/4', DepositTypeId]);
    } else if (e == 'apcoicardmaster') {
      this._router.navigate(['/depositapco/4', DepositTypeId]);
    } else if (e == 'paypal') {
      this._router.navigate(['/depositpaypal/0', DepositTypeId]);
    } else if (e == 'depositskrill') {
      this._router.navigate(['/depositskrill/0', DepositTypeId]);
    } else if (e == 'depositneteller') {
      this._router.navigate(['/depositneteller/0', DepositTypeId]);
    }
    window.scroll(0, 0);
  }

  goPage(pageId) {
    window.scroll(0, 0);

    // window.open('https://www.authorisation.mga.org.mt/verification.aspx?lang=EN&company=3b610148-3a59-4841-b0e2-b75519caa325&details=1');
    if (pageId == 0) window.open('https://help.wettarena.com');
    // Informationen
    else if (pageId == 101)
      // AGB
      window.open('https://help.wettarena.com/_5vr10uqj9.htm');
    else if (pageId == 102)
      // Spielerschutz
      window.open('https://help.wettarena.com/_5vr12mfgb.htm');
    else if (pageId == 103)
      // Datenschutz & Cookies
      window.open('https://help.wettarena.com/_5vx0udpsj.htm');
    else if (pageId == 104)
      // Wett- und Sportregeln
      window.open('https://help.wettarena.com/_5g112o3u7.htm');
    else if (pageId == 105)
      // Cashout
      window.open('https://help.wettarena.com/_5g111pqi3.htm');
    else if (pageId == 106)
      // Sport- und Livewetten
      window.open('https://help.wettarena.com/_5g10y1piz.htm');
    else if (pageId == 107)
      // Facebook
      window.open('https://www.facebook.com/WettarenaSportwetten/');
    else if (pageId == 108)
      // Instagram
      window.open('https://www.instagram.com/wettarena/');
    else if (pageId == 109)
      // Linkedin
      window.open('https://www.linkedin.com/company/wettarena');
    else if (pageId == 110)
      // TikTok
      window.open('https://vm.tiktok.com/ZMed5tRat/');
    else if (pageId == 111)
      // Youtube
      window.open('https://youtube.com/channel/UC3uQBztIWEb3hcIVbVmnu4Q');
    else if (pageId == 112)
      // Twitter
      window.open('https://twitter.com/wettarena_de');
    // Informationen
    //Help Center
    else if (pageId == 201)
      // Registrierung
      window.open('https://help.wettarena.com/_5g10w1d1b.htm');
    else if (pageId == 202)
      // Konto/Login
      window.open('https://help.wettarena.com/_5g10wvkho.htm');
    else if (pageId == 203)
      // Zahlung/Einsätze
      window.open('https://help.wettarena.com/_5g10xb6lp.htm');
    else if (pageId == 204)
      // Sicherheit
      window.open('https://help.wettarena.com/_5g10xre2x.htm');
    else if (pageId == 205)
      // Jugendschutz
      window.open('https://help.wettarena.com/_5w312cgvu.htm');
    else if (pageId == 206)
      // Technik/Support
      window.open('https://help.wettarena.com/_5g10xy4m6.htm');
    else if (pageId == 207) {
      // Technik/Support
      // window.open('https://help.wettarena.com/_5g10xb6lp.htm');
      if (this._UserHelper.isSignedIn) this._router.navigate(['/deposit']);
      else this._router.navigate(['/register']);
    }
    //Help Center

    // Unternehmen
    else if (pageId == 301)
      // Über uns
      window.open('https://help.wettarena.com/_5w312cgvu.htm');
    else if (pageId == 302)
      // Impressum
      window.open('https://help.wettarena.com/_5vr147g13.htm');
    else if (pageId == 303)
      // Impressum
      window.open('https://wettarena-shop.com/');
    else if (pageId == 304)
      // Über Uns
      window.open('https://help.wettarena.com/_5w3128s82.htm');
    else if (pageId == 305)
      // Über Uns
      window.open('https://help.wettarena.com/_5wg11cru1.htm');
    //Unternehmen
    // Last Row
    else if (pageId == 401)
      // bgza.de
      window.open('http://www.bzga.de/');
    else if (pageId == 402)
      // Logo
      window.open('https://www.gamblingtherapy.org/de');
    // Last Row
    // SSL +18
    else if (pageId == 501)
      // bgza.de
      window.open('https://help.wettarena.de/_5g10xre2x.htm');
    else if (pageId == 502)
      // Logo
      window.open('https://www.gamblingtherapy.org/de');
    else if (pageId == 503)
      // Logo
      window.open('https://help.wettarena.de/_5vr12mfgb.htm');
    // SSL +18
  }

  selectionChange(x) {
    this._LocalizationService.changeLang(x);
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }
  toggleLanguageMenu() {
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }

  getMatch(tournament) {
    this.selectedLeagueData = [];
    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: tournament.TournamentName,
      SportId: 1,
      SportName: 'Fußball',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }
}
